export enum SupplierTypesTag {
    HOTEL = 'HOTEL',
    RENTALS = 'RENTALS',
    AIRLINE_COMPANIES = 'AIRLINE_COMPANIES',
    SHIPPING_COMPANIES = 'SHIPPING_COMPANIES',
    RAILWAY_COMPANIES = 'RAILWAY_COMPANIES',
    ORDINARY = 'ORDINARY',
    TOUR_OPERATORS = 'TOUR_OPERATORS',
    COLLABORATORS_WITHHOLDING_TAX = 'COLLABORATORS_WITHHOLDING_TAX',
    BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
}
